import {Theme} from "./theme.model";
import {environment} from "../../../../../environments/environment";

// the initial state
export const initialThemeState: Theme = new Theme({...environment.rondeivu_colors.default_theme});

